import React from 'react'

const RedixpressHealth = () => {
  return (
    <div className='text-center pt-5 pb-5 bg-gray'>
      <h1>Coming Soon</h1>
    </div>
  )
}

export default RedixpressHealth
